import { createSelector } from "reselect";

const selectAuth = (state) => state.auth;

export const selectSigninStatus = createSelector([selectAuth], (auth) => {
    return {
        signinSuccess: auth.signinSuccess,
        loading: auth.loading,
        error: auth.errorMessage,
        employee: auth.employee,
        isCodeValid: auth.isCodeValid,
        code: auth.code,
        appId: auth.appId,
    };
});

export const selectSubscriptionData = createSelector([selectAuth], (auth) => {
    return {
        subscriptions: auth.subscriptions,
        subscription: auth.subscription,
        vertical: auth.vertical,
        employee: auth.employee,
        appId: auth.appId,
    };
});
